<template>
  <b-container class="py-4">
    <b-breadcrumb>
      <b-breadcrumb-item @click="goToAdminPanel">
        <b-icon aria-hidden="true" icon="people-fill" scale="1.25" shift-v="1.25"></b-icon>
        Users
      </b-breadcrumb-item>
      <b-breadcrumb-item active>Create</b-breadcrumb-item>
    </b-breadcrumb>
    <b-card no-title>
      <b-card-text>
        <b-form @submit.prevent="onSubmit">
          <create-user-form @updateForm="updateForm" />
          <div class="text-right">
            <b-button :disabled="busy" pill type="submit" variant="primary"
              >OK
              <div v-if="busy" style="display: inline;">
                <b-spinner small></b-spinner>
                <span class="sr-only">Loading...</span>
              </div>
            </b-button>
          </div>
        </b-form>
      </b-card-text>
    </b-card>
  </b-container>
</template>

<script>
  import CreateUserForm from './CreateUserForm';
  import { mapMutations } from 'vuex';

  export default {
    name: 'CreateUser',
    components: { CreateUserForm },
    data() {
      return {
        busy: false,
        form: {},
        userId: '',
      };
    },
    computed: {
      userForm: {
        get() {
          return this.$store.state.salesforceUserForm.userForm;
        },
        set(form) {
          this.$store.commit('salesforceUserForm.updateForm', form);
        },
      },
    },
    methods: {
      ...mapMutations({
        setForm: 'updateUserForm',
      }),
      goToAdminPanel() {
        this.$router.push({ name: 'salesforce-admin-panel' });
      },
      updateForm(userForm) {
        this.form = userForm;
      },
      async onSubmit() {
        this.busy = true;
        this.form.name = this.form.firstName + ' ' + this.form.lastName;
        await axios
          .post(`/api/salesforce/users/`, this.form)
          .then(results => {
            let user = results.data.data;
            this.setForm(user);
            this.$router
              .push({ name: 'salesforce-user-profile', params: { userId: user.ID } })
              .then(res => {
                this.userCreated();
              });
          })
          .catch(err => {
            console.error(err.response.data);
            let error = err.response.data.error;
            if (error.message === 'Already exists!') {
              this.promptToRedirect(error);
            }
            this.handleError(err, `Could Not Create User - ${error.message}`);
          });
        this.busy = false;
      },

      promptToRedirect(error) {
        this.$bvModal
          .msgBoxConfirm("Do you want to be redirected to the user's profile?", {
            title: 'User already exists',
            size: 'sm',
            buttonSize: 'sm',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          })
          .then(value => {
            if (value) {
              let user = error.data;
              this.setForm(user);
              this.$router.push({ name: 'salesforce-user-profile', params: { userId: user.ID } });
            }
          });
      },
      handleError(error, message) {
        console.log(error);
        this.$bvToast.toast(message, {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
          variant: 'danger',
        });
      },
      userCreated() {
        this.$bvToast.toast('User Created', {
          title: 'Success',
          autoHideDelay: 5000,
          appendToast: true,
          variant: 'success',
        });
      },
    },
  };
</script>
